/** External dependencies */
import { Alert, Button, Collapse, Dropdown, Modal, Scrollspy, Tab, Toast, Tooltip } from 'bootstrap';

/** Internal dependencies */
import whenDocumentReady from './utilities/whenDocumentReady';
import { defineScrollbarWidth, setHeaderHeight, throttle } from './utilities';

// add `Tab` if you need ws forms paging/tabs > it assumes Tab bound to the window.bootstrap object
window.bootstrap = { Toast, Tooltip };

window.bootstrapDetectBreakpoint = function () {
    const breakpointNames = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
    let breakpointValues = [];

    for (const breakpointName of breakpointNames) {
        breakpointValues[breakpointName] = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--bs-breakpoint-' + breakpointName);
    }

    let i = breakpointNames.length;
    for (const breakpointName of breakpointNames) {
        i--;
        if (window.matchMedia('(min-width: ' + breakpointValues[breakpointName] + ')').matches) {
            return breakpointName;
        }
    }

    return null;
};

window.getBootstrapBreakpointWidth = function () {
    const breakpointNames = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
    let breakpointValues = [];

    for (const breakpointName of breakpointNames) {
        breakpointValues[breakpointName] = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--bs-breakpoint-' + breakpointName);
    }

    let i = breakpointNames.length;
    let prevSize = breakpointValues['xxl'];

    for (const breakpointName of breakpointNames) {
        i--;

        if (window.matchMedia('(min-width: ' + breakpointValues[breakpointName] + ')').matches) {
            return parseInt(prevSize.substr(0, prevSize.length - 2));
        }

        prevSize = breakpointValues[breakpointName];
    }

    return null;
};

whenDocumentReady(initTheme);

function initTheme() {
    document.documentElement.style.setProperty(
        '--scrollbar-width',
        window.innerWidth - document.documentElement.clientWidth + 'px'
    );

    throttle('resize', 'optimizedResize');
    window.addEventListener('optimizedResize', defineScrollbarWidth);
    defineScrollbarWidth();
    window.addEventListener('optimizedResize', setHeaderHeight);
    setHeaderHeight();

    document.querySelector('main').classList.add('initialized');
}

// wsform multi language
if (typeof jQuery !== 'undefined') {
    jQuery(function ($) {
        $(document).on('wsf-rendered', function (e, form, form_id, instance_id) {
            const wsForm = document.querySelector(`.wsf-form[data-id="${form_id}"]`);
            const wsfLang = document.createElement('input');
            wsfLang.type = 'hidden';
            wsfLang.name = 'lang';
            wsfLang.value = 'de';
            wsForm.appendChild(wsfLang);
        });
    });
}
